import SiafLiteNfeRepository from "../../external/siafLiteNfe";

class NfeService {
  constructor() {
    this.urlBase = "/nfce";
    this.urlBaseNfse = "/nfse";
  }

  baixarXml(cnpj, ano, mes) {
    return new SiafLiteNfeRepository(
      `${this.urlBase}/${cnpj}/xml/${ano}/${mes}`,
    ).getFile();
  }

  baixarXmlNfse(cnpj, ano, mes) {
    return new SiafLiteNfeRepository(
      `${this.urlBaseNfse}/${cnpj}/xml/${ano}/${mes}`,
    ).getFile();
  }

  baixarDanfeNfse(cnpj, idNota) {
    return new SiafLiteNfeRepository(
      `${this.urlBaseNfse}/${cnpj}/danfe/${idNota}`,
    ).get();
  }

  baixarXmlIndividual(cnpjCpf, chaveXml) {
    return new SiafLiteNfeRepository(
      `${this.urlBase}/${cnpjCpf}/consulta-sefaz/${chaveXml}`,
    ).get();
  }
}

export default NfeService;
